<template>
  <v-container v-if="news != null">
    <v-card class="mx-auto my-12" max-width="50%">
      <v-card-title>
        {{ shalgalt.ref.path }}
        <v-spacer></v-spacer>
        <v-col md="auto" lg="auto" cols="12">
          <v-row>
            <v-btn color="black" @click="_answerAsuulga" class="mr-3"
              >Xариулаx</v-btn
            >
            <v-btn
              class="mr-3"
              title="Асуулт боловсруулаx"
              v-if="
                news.userId == userProfile.customer.id ||
                userProfile.role == 'admin' ||
                userProfile.role == 'manager' ||
                userProfile.role == 'sts' ||
                (news.createdBy != null &&
                  news.createdBy != undefined &&
                  userProfile.customer.path == news.createdBy.path)
              "
              @click="_editAsuulga"
            >
              Засаx
            </v-btn>
            <v-btn
              color="#FF5252"
              dark
              title="Үр дүн xараx"
              v-if="
                news.userId == userProfile.customer.id ||
                userProfile.role == 'admin' ||
                userProfile.role == 'manager' ||
                userProfile.role == 'sts' ||
                (news.createdBy != null &&
                  news.createdBy != undefined &&
                  userProfile.customer.path == news.createdBy.path)
              "
              @click="_seeResults"
            >
              Үр дүн
            </v-btn>
          </v-row>
        </v-col>
      </v-card-title>
      <v-card-text>
        <div>{{ news.description }}</div>
      </v-card-text>

      <div
        v-if="
          (news.createdBy &&
            userProfile.customer.path == news.createdBy.path) ||
          userProfile.role == 'admin' ||
          userProfile.role == 'manager' ||
          userProfile.role == 'sts'
        "
      >
        <v-card-text v-if="userclasses && !this.news.forAllStudent">
          <p v-for="(level, lindex) in userclasses" :key="lindex">
            <v-row justify="space-between">
              <div>
                <v-chip
                  @click="_selectOrDeselectClass(level, classs)"
                  class="mx-2"
                  :class="
                    _isContained(classs) ? 'chip-selected' : 'chip-deselected'
                  "
                  v-for="(classs, ccindex) in level.classes"
                  :key="ccindex"
                  ><small>{{ level.name }}{{ classs.name }}</small></v-chip
                >
              </div>
              <v-btn
                text
                class="chip-selected"
                v-if="level.selected"
                @click="_selectLevel(level)"
                >сонгосон</v-btn
              >
              <v-btn
                text
                style="font-size: 8pt"
                v-else
                @click="_selectLevel(level)"
                >Сонгоогүй</v-btn
              >
            </v-row>
          </p>
        </v-card-text>
      </div>
      <v-card-actions>
        <v-container class="text-center" v-if="news.videoUrl != null">
          <iframe
            width="100%"
            height="400"
            :src="getXYoutubeIframe(news.videoUrl)"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import myfunction from "../../global/myfunction.js";
const fb = require("../../../firebaseConfig.js");

export default {
  data() {
    return {
      news: null,
      parentPath: null,
      userclasses: [],
      xchanged: false,
      customerData: null,
    };
  },
  mixins: [myfunction],

  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  props: {
    shalgalt: {
      type: Object,
      required: true,
    },
    // userId: {
    //   required: true,
    // },
  },

  methods: {
    _seeResults() {
      console.log(this.shalgalt)
      this.$router.push({
        name: "XShalgaltResults",
        params: {item:this.shalgalt},
      });
    },
    _editAsuulga() {
      console.log(this.shalgalt.ref.path);
      this.$router.push({
        name: "XShalgaltEditing",
        params: {
          shalgalt: this.shalgalt,
        },
      });
    },
    _answerAsuulga() {
      this.$router.push({
        name: "XShalgaltAnswering",
        params: {
          item: this.shalgalt,
          showScores:true
        },
      });
    },
    _checkForStudent(evt) {
      this._updateNews();
    },
    _allowForAllStudent() {
      this.news.forAllStudent = !this.news.forAllStudent;
    },
    _isContained(classs) {
      if (this.news.userclasses) {
        for (var xx of this.news.userclasses) {
          if (xx.ref.path == classs.ref.path) return true;
        }
      }
      return false;
    },
    _saved() {
      var selectedClasses = [];
      for (var level of this.userclasses) {
        for (var cls of level.classes) {
          if (cls.selected) selectedClasses.push(cls.ref);
        }
      }
      this.news.ref.update({ userclasses: selectedClasses }).then(() => {
        this.$router.back();
      });
    },
    _selectLevel(level) {
      for (var cls of level.classes) {
        this._selectOrDeselectClass(level, cls);
      }
    },
    _selectOrDeselectClass(level, classs) {
      //level.classes.push({name: data.name, ref:doc.ref, selected:true, tt:'tt'})
      var removed = false;
      for (var i = 0; i < this.news.userclasses.length; i++) {
        const cls = this.news.userclasses[i];
        if (cls.ref.path == classs.ref.path) {
          this.news.userclasses.splice(i, 1);
          removed = true;
          break;
        }
      }
      if (!removed)
        this.news.userclasses.push({
          name: level.name + classs.name,
          ref: classs.ref,
        });

      this._updateNews();
    },
    _updateNews() {
      fb.db
        .collection("schools/" + this.schoolId + "/asuulga")
        .doc(this.asuulgaId)
        .update(this.news);
    },
    _delete() {
      var yes = confirm(this.news.ref.path + " та устгаxад итгэлтэй байна уу?");
      if (yes) {
        this.news.ref.delete().then(() => {
          this.$router.back();
        });
      }
    },
    _read() {
      if (this.userProfile.customer) {
        this.userProfile["customer"].get().then((doc) => {
          let data = doc.data();
          data.ref = doc.ref;
          data.id = doc.id;
          this.customerData = data;
        });
      }

      //this.parentPath = "schools/" + this.schoolId + "/asuulga";
      this.parentPath = this.shalgalt.ref.path;
 
      this.shalgalt.ref.onSnapshot((doc) => {
        let object = doc.data();
        object.id = doc.id;
        object.ref = doc.ref;
        this.news = object;
        if (!this.news.userclasses) this.news.userclasses = [];
      });

      // fb.db
      //   .collection("schools/" + this.schoolId + "/departments")
      //   .orderBy("index", "asc")
      //   .get()
      //   .then((querySnapshot) => {
      //     querySnapshot.forEach((doc) => {
      //       let level = doc.data();
      //       level.ref = doc.ref;
      //       level.id = doc.id;
      //       level.classes = [];
      //       level.selected = true;
      //       fb.db
      //         .collection(
      //           "schools/" +
      //             this.schoolId +
      //             "/departments/" +
      //             doc.id +
      //             "/programs"
      //         )
      //         .orderBy("index", "asc")
      //         .get()
      //         .then((querySnapshot) => {
      //           level.classes = [];
      //           querySnapshot.forEach((doc) => {
      //             let data = doc.data();
      //             //let classs = {name: data.name, id: doc.id, selected:false, ref:doc.ref};
      //             //console.log(classs)
      //             level.classes.push({
      //               name: data.name,
      //               ref: doc.ref,
      //               selected: true,
      //               tt: "tt",
      //             });
      //           });
      //         });
      //       this.userclasses.push(level);
      //     });
      //   });
    },
  },
  created() {
    this.userclasses = [];
    $('[data-toggle="tooltip"]').tooltip();

    this._read();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
